import React, { Component } from "react";
import { NavLink, Link } from "react-router-dom";
import MediaQuery from "react-responsive";
import Icon from '../../../components/UI/Icon/Icon';
/**
 * @desc Footer component
 * @param props
 * @return null
 */
const Commonfooter = props => {
  return (
    <span className="footer-common">
      {/* Mobile View Section starts */}
      <MediaQuery query="(max-device-width: 769px)">
      <div className="brand-section">
      <Icon icon="mmk-group-mob" className ="mmk-group" /> 
      <Icon icon="mmk-beyond-mob" className ="mmk-beyond" />
      <Icon icon="la-creme-mob" className ="la-creme" /></div>
        <p>
          <a href={"https://privacy.morganmckinley.com/"} target="_blank">
            Privacy Policy
          </a>
          &nbsp; | &nbsp;
          <NavLink
            activeClassName="is-active"
            to={"/content-pages/TermsAndConditions"}
            onClick={() => window.scrollTo(0, 0)}
            target="_blank"
          >
            User Terms & Conditions
          </NavLink>
          {/* &nbsp; | &nbsp;
          <NavLink
            activeClassName="is-active"
            to={"/content-pages/SecurityPolicy"}
            onClick={() => window.scrollTo(0, 0)}
          >
            Security Policy
          </NavLink> */}
        </p>
        <p className="footer-nolink">Morgan McKinley © 2020</p>
      </MediaQuery>
      {/* Mobile View Section ends */}

      {/* Desktop View Section starts */}
      <MediaQuery query="(min-device-width: 768px)">
      <div className="footer-brands">
      <Icon icon="mmk-group-des" className ="mmk-group" /> 
      <Icon icon="mmk-beyond-des" className ="mmk-beyond" />
      <Icon icon="la-creme-des" className ="la-creme" />
      </div>
      <div className="footer-content">
        <p className="footer-nolink">Morgan McKinley © 2020</p> &nbsp; | &nbsp;
        <a href={"https://privacy.morganmckinley.com/"} target="_blank">
          Privacy Policy
        </a>
        &nbsp; | &nbsp;
        <NavLink
          activeClassName="is-active"
          to={"/content-pages/TermsAndConditions"}
          onClick={() => window.scrollTo(0, 0)}
          target="_blank"
        >
          User Terms & Conditions
        </NavLink>
        {/* &nbsp; | &nbsp;
        <NavLink
          activeClassName="is-active"
          to={"/content-pages/SecurityPolicy"}
          onClick={() => window.scrollTo(0, 0)}
        >
          Security Policy{" "}
        </NavLink> */}
        </div>
      </MediaQuery>
      {/* Desktop View Section ends */}
    </span>
  );
};

export default Commonfooter;



// WEBPACK FOOTER //
// ./src/components/UI/FooterCommon/Commonfooter.js